import { NormalizeOAS, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';

const PATH = '/api/v2/asset-library-access';

export type AssetLibraryAccess = {
  companyId: Guid;
};

export type ApiFunction = (signal?: AbortSignal) => Promise<AssetLibraryAccess>;

/**
 * The one route not scoped to a company, because it is what resolves the company.
 *
 * Asked only by a front-end dev server, which has no host page to inject the company with the rest
 * of its inline config -- and the folder to open comes from that same page, so this does not answer
 * it.
 */
export const createGetAssetLibraryAccess = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const getAssetLibraryAccess = async (signal?: AbortSignal): Promise<AssetLibraryAccess> => {
    const response = await apiClient[PATH].get({ ...(signal && { signal }) });

    return convertResponse(response);
  };

  return getAssetLibraryAccess;
};

type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'get'>;

const convertResponse = async (response: Response): Promise<AssetLibraryAccess> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const data = await response.json();
  return { companyId: data.companyId };
};
